const AnimatedVideoIcons = (function () {
  function init() {
    $(document).ready(function () {
      const animatedVideoElements = document.querySelectorAll(
        ".js-animated-icon-video",
      );

      const handleIntersection = (
        entries: IntersectionObserverEntry[],
        observer: IntersectionObserver,
      ) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const video = entry.target as HTMLVideoElement;
            video.play();
            observer.unobserve(video);
          }
        });
      };

      const observer = new IntersectionObserver(handleIntersection, {
        root: null,
        threshold: 0.2,
      });

      animatedVideoElements.forEach((el) => observer.observe(el));
    });
  }

  return {
    init,
  };
})();

export default AnimatedVideoIcons;
